export default __webpack_public_path__ + "static/media/1.683bd3a1.jpg";